import React, { useState, useEffect } from "react";
import "./GcalcPage.css";
import BASE_URL from "../apiConfig";
import useRecaptcha from "../hooks/useRecaptcha";
import introImg from "../images/assetandgold.png";
import solutionImg from "../images/jewelhome10.png";
import inventoryImg from "../images/inventory.jpg";
import reportingImg from "../images/reporting.jpg";
import technopark from "../images/technopark.jpg";

function GcalcPage() {

    const [widgetId, setWidgetId] = useState(null);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const { getResponse } = useRecaptcha();

    useEffect(() => {
        if (window.grecaptcha) {
            const container = document.getElementById("recaptcha-gcalc");
            if (container && container.innerHTML === "") {
                try {
                    const id = window.grecaptcha.render(container, {
                        // sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
                         sitekey: window.RECAPTCHA_SITE_KEY,
                    });
                    setWidgetId(id);
                } catch (err) {
                    console.error("reCAPTCHA GcalcPage render error:", err);
                }
            }
        }
    }, []);

    const [formData, setFormData] = useState({
        full_name: "",
        phone: "",
        email: "",
        organization: "",
        challenges: ""
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.full_name || !formData.phone) {
            setMessage("❌ Name & Phone required");
            return;
        }

        setLoading(true);

        try {
            const token = getResponse(widgetId);
            if (!token) {
                setMessage("❌ Please complete the reCAPTCHA");
                setLoading(false);
                return;
            }
            const fd = new FormData();
            Object.keys(formData).forEach(k => fd.append(k, formData[k]));
            fd.append("_type", "gcalc_demo");
            fd.append("tk", token);

            const res = await fetch(
                BASE_URL + "/DemoApi/saveData",
                { method: "POST", body: fd }
            );

            const result = await res.json();

            if (result.status) {
                setMessage("✅ Demo Request Submitted");
                setFormData({
                    full_name: "",
                    phone: "",
                    email: "",
                    organization: "",
                    challenges: ""
                });
            } else {
                setMessage("❌ " + (result.message || "Verification Failed"));
            }

        } catch (err) {
            console.error("Submission Error:", err);
            setMessage("❌ Submission Failed. Check Console.");
        }

        setLoading(false);
    };

    return (
        <>

            {/* HERO */}
            <div
                className="bg-container-gcalc"
                style={{ backgroundImage: `url(${technopark})` }}
            ></div>

            <div className="gcalc-wrapper">

                <div className="gcalc-left">

                    <h1>IGNOSI - GCALC</h1>
                    <h2>Gold Loan Finance Management Software</h2>

                    <p>
                        G-Calc is a powerful gold loan finance solution
                        designed to manage billing, accounting,
                        inventory tracking and gold loan operations
                        through one intelligent platform.
                    </p>

                    <ul>
                        <li>Gold Loan Accounting</li>
                        <li>Inventory & Jewellery Tracking</li>
                        <li>Automated Interest Calculation</li>
                        <li>Integrated Reporting System</li>
                    </ul>

                </div>

                <div className="gcalc-right">

                    <form
                        className="demo-form-gcalc"
                        onSubmit={handleSubmit}
                    >

                        <input name="full_name"
                            placeholder="Full Name*"
                            value={formData.full_name}
                            onChange={handleChange}
                        />

                        <input name="phone"
                            placeholder="Phone Number*"
                            value={formData.phone}
                            onChange={handleChange}
                        />

                        <input name="email"
                            placeholder="Email Address"
                            value={formData.email}
                            onChange={handleChange}
                        />

                        <input name="organization"
                            placeholder="Finance Company"
                            value={formData.organization}
                            onChange={handleChange}
                        />

                        <textarea
                            name="challenges"
                            placeholder="Your Requirement"
                            value={formData.challenges}
                            onChange={handleChange}
                        />

                        <div
                            id="recaptcha-gcalc"
                            style={{ marginBottom: "15px" }}
                        ></div>

                        <button type="submit" disabled={loading}>
                            {loading ? "Submitting..." : "Book a Demo"}
                        </button>

                        {message &&
                            <p className="form-msg-gcalc">{message}</p>}

                    </form>

                </div>

            </div>


            {/* INTRO */}
            <div className="gcalc-intro-wrapper">
                <section className="gcalc-intro-section animate-fadeInUp">
                    <div className="intro-content-vibrant">
                        <h2 className="gradient-text">What is G-Calc?</h2>
                        <p>
                            IGNOSI G-Calc is an all-inclusive gold loan
                            management software enabling seamless
                            customer handling, stock tracking,
                            NPA monitoring and automated statutory
                            report generation simplifying daily
                            gold finance operations.
                        </p>
                    </div>
                    <div className="intro-image-vibrant">
                        <img src={introImg} alt="Gold Loan Management" />
                    </div>
                </section>
            </div>


            {/* SOLUTIONS - SMART FINANCE */}
            <section className="gcalc-solutions-vibrant white-bg">
                <div className="section-header-vibrant animate-fadeInUp">
                    <h2 className="gradient-text">Smart Finance Technology</h2>
                    <p className="subtitle-vibrant">Transforming Gold Loan Operations with Precision and Intelligence</p>
                </div>

                <div className="solution-layout-vibrant">
                    <div className="solution-content-grid">
                        {[
                            {
                                title: "Debt Collection Technology",
                                desc: "Real-time customer data enables structured follow-ups improving recovery efficiency."
                            },
                            {
                                title: "Business Tracking",
                                desc: "Advanced reporting eliminates manual work and improves operational visibility."
                            },
                            {
                                title: "Turn-Key Solution",
                                desc: "Accurate customer information ensures faster loan collection and growth."
                            },
                            {
                                title: "Cloud Communication",
                                desc: "365-day cloud access makes communication easy from anywhere."
                            },
                            {
                                title: "Optimised Platform",
                                desc: "Always accessible, scalable and future-ready gold finance ecosystem."
                            }
                        ].map((item, idx) => (
                            <div key={idx} className="solution-card-vibrant animate-fadeInUp" style={{ animationDelay: `${idx * 0.1}s` }}>
                                <h3>{item.title}</h3>
                                <p>{item.desc}</p>
                            </div>
                        ))}
                    </div>
                    <div className="solution-visual-vibrant animate-fadeInUp">
                        <img src={solutionImg} alt="Smart Finance Solutions" />
                    </div>
                </div>
            </section>

            {/* INVENTORY & REPORTING */}
            <section className="gcalc-features-spread bg-offset-light">
                <div className="feature-spread-row animate-fadeInUp">
                    <div className="spread-image">
                        <img src={inventoryImg} alt="Inventory Management" />
                    </div>
                    <div className="spread-content">
                        <h2 className="gradient-text">Inventory & Stock Tracking</h2>
                        <p>
                            Advanced item-level tracking with physical verification support. Manage stone weights, purity levels, and storage locations with precision.
                        </p>
                        <ul className="vibrant-check-list">
                            <li>Jewellery Specification Tracking</li>
                            <li>Packet Management</li>
                            <li>Automatic Valuation Syncing</li>
                        </ul>
                    </div>
                </div>

                <div className="feature-spread-row reverse animate-fadeInUp">
                    <div className="spread-image">
                        <img src={reportingImg} alt="Automated Reporting" />
                    </div>
                    <div className="spread-content">
                        <h2 className="gradient-text">NPA & Regulatory Reporting</h2>
                        <p>
                            Automated statutory reporting and NPA tracking ensures your business stays compliant with the latest financial regulations without manual effort.
                        </p>
                        <ul className="vibrant-check-list">
                            <li>Auction Management System</li>
                            <li>Interest Calculation Engine</li>
                            <li>Comprehensive Ledger Reports</li>
                        </ul>
                    </div>
                </div>
            </section>


            {/* WHY GCALC */}
            <section className="gcalc-why-vibrant white-bg">
                <h2 className="gradient-text section-title-center animate-fadeInUp">Why Choose IGNOSI G-Calc?</h2>

                <div className="why-grid-vibrant">
                    {[
                        "Dynamic Gold Loan Calculator",
                        "Automated Accounting System",
                        "Custom Scalable Reporting",
                        "Real-time Inventory Sync",
                        "Advanced NPA Handling",
                        "Enterprise Cloud Platform"
                    ].map((item, i) => (
                        <div key={i} className="why-card-vibrant animate-fadeInUp" style={{ animationDelay: `${i * 0.1}s` }}>
                            <div className="why-icon">✓</div>
                            <p>{item}</p>
                        </div>
                    ))}
                </div>

            </section>

        </>
    );
}

export default GcalcPage;
